// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { supabase, callProxy } from '../supabase';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  // Hardcode admin user data - bypass API call
  return Promise.resolve({
    data: {
      name: 'COW Admin',
      avatar: '/logo.png',
      userid: '00000001',
      email: 'admin@cow.wallet',
      signature: 'COW Wallet Administrator',
      title: 'Admin',
      group: 'COW WALLET ADMIN SYSTEM',
      tags: [
        { key: '0', label: 'Admin' },
        { key: '1', label: 'Manager' },
      ],
      notifyCount: 0,
      unreadCount: 0,
      country: 'Vietnam',
      access: 'admin',
      geographic: {
        province: { label: 'Hà Nội', key: '110000' },
        city: { label: 'Hà Nội', key: '110100' },
      },
      address: 'Hà Nội, Vietnam',
      phone: '0123-456-789',
    },
  });

  // Original API call (commented out)
  // return request<{
  //   data: API.CurrentUser;
  // }>('/api/currentUser', {
  //   method: 'GET',
  //   ...(options || {}),
  // });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));

  try {
    console.log('🔐 Attempting login via Proxy for:', body.username);

    const users = await callProxy({
      action: 'select',
      table: 'admin_users',
      select: '*',
      eqField: 'username',
      eqValue: body.username
    });

    const user = users && users.length > 0 ? users[0] : null;

    // Fallback: Kiểm tra hardcoded cow_admin nếu DB không có hoặc sai
    const HARDCODED_USERNAME = 'cow_admin';
    const HARDCODED_PASSWORD = 'Nghi@793#nguyen1605_admin';

    if (!user) {
      if (body.username === HARDCODED_USERNAME && body.password === HARDCODED_PASSWORD) {
        localStorage.setItem('cow_last_login', new Date().toISOString());
        localStorage.setItem('cow_current_user_id', 'cow_admin');
        localStorage.setItem('cow_current_username', HARDCODED_USERNAME);

        return {
          status: 'ok',
          type: body.type,
          currentAuthority: 'admin',
        };
      }
      return { status: 'error', type: body.type, currentAuthority: 'guest' };
    }

    // Kiểm tra password_hash (So sánh trực tiếp vì hệ thống đang dùng plain text)
    if (user.password_hash !== body.password) {
      // Nếu là cow_admin, thử thêm pass hardcoded
      if (body.username === HARDCODED_USERNAME && body.password === HARDCODED_PASSWORD) {
        localStorage.setItem('cow_last_login', new Date().toISOString());
        localStorage.setItem('cow_current_user_id', user.id);
        localStorage.setItem('cow_current_username', user.username);
        return { status: 'ok', type: body.type, currentAuthority: 'admin' };
      }

      console.log('❌ Password mismatch');
      return { status: 'error', type: body.type, currentAuthority: 'guest' };
    }

    // Login thành công
    console.log('✅ Login success for user:', user.username);
    localStorage.setItem('cow_last_login', new Date().toISOString());
    localStorage.setItem('cow_current_user_id', user.id);
    localStorage.setItem('cow_current_username', user.username);

    // Cập nhật last_login_at bằng Proxy
    await callProxy({
      action: 'update',
      table: 'admin_users',
      data: { last_login_at: new Date().toISOString() },
      eqField: 'id',
      eqValue: user.id
    });

    return {
      status: 'ok',
      type: body.type,
      currentAuthority: 'admin',
    };
  } catch (err) {
    console.error('🔥 Login error:', err);
    return {
      status: 'error',
      type: body.type,
      currentAuthority: 'guest',
    };
  }
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
